import type { Database } from '../../types/database.generated'

export type DocumentRecord = Database['public']['Tables']['documents']['Row']
export type DocumentVersion = Database['public']['Tables']['document_versions']['Row']
export type DocumentCategory = Database['public']['Enums']['document_category']

export interface DocumentWorkspace {
  documents: DocumentRecord[]
  versions: DocumentVersion[]
  assessmentId: string | null
  questions: Array<{ id: string; prompt: string }>
}

export const acceptedFileTypes = [
  'application/pdf', 'image/jpeg', 'image/png', 'image/webp',
  'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
]

export function expirationState(expiresOn: string | null, today = new Date()): 'none' | 'expired' | 'soon' | 'current' {
  if (!expiresOn) return 'none'
  const expiration = new Date(`${expiresOn}T00:00:00`)
  const todayStart = new Date(today)
  todayStart.setHours(0, 0, 0, 0)
  if (expiration < todayStart) return 'expired'
  const days = Math.ceil((expiration.getTime() - todayStart.getTime()) / 86_400_000)
  if (days <= 30) return 'soon'
  return 'current'
}
